// This is super legacy and needs to be removed at some point.

class Event {
  constructor(params = {}) {
    this.params = params;

    Object.keys(params).forEach(key => {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        this[key] = params[key];
      }
    });
  }

  isUserHostOrAdmin(user) {
    // Data isn't loaded yet.
    if (!this || !this.host || !this.host.id || !user) {
      return false;
    }

    // User is the host.
    if (this.host.id === user.id) {
      return true;
    }

    // User is an admin
    if (user.organizationAdmin) {
      return true;
    }

    return false;
  }

  isLive() {
    const currentTime = new Date();

    const halfBeforeAt = new Date(this.startsAt);
    halfBeforeAt.setMinutes(halfBeforeAt.getMinutes() - 30);

    const endsAt = new Date(this.endsAt);

    return currentTime >= halfBeforeAt && currentTime < endsAt;
  }

  isPast() {
    const currentTime = new Date();
    const endsAt = new Date(this.endsAt);

    return currentTime > endsAt;
  }

  canUserRSVP() {
    return (
      !this.isPast()
      && !this.cancelledAt
      && (!this.inviteOnly || (this.rsvpForUser && this.rsvpForUser.responseType))
    );
  }
}

export default Event;
